import { render } from "./SmallInput.vue?vue&type=template&id=aa765144&scoped=true"
import script from "./SmallInput.vue?vue&type=script&lang=js"
export * from "./SmallInput.vue?vue&type=script&lang=js"

import "./SmallInput.vue?vue&type=style&index=0&id=aa765144&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa765144"]])

export default __exports__